import QuestionValueTexture from "../QuestionValueTexture";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleVisual extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        const range = P3.utils.objectToArray(data.range);
        const answer = P3.utils.selectRandom(range);
        question.values = [new QuestionValueTexture(answer.value, answer.name, P3.assets.texture(answer.image))];
        question.options = this.generateOptions(question, data.values, range);
        return question;
    }

    generateOptions(question, count) {
        const range = P3.utils.objectToArray(question.range);
        const options = question.values.slice(0);

        let k = 200;
        while (options.length < count && --k > 0) {
            const t = P3.utils.selectRandom(range);
            if (options.every(x => x.value !== t.value)) {
                options.push(new QuestionValueTexture(t.value, t.name, P3.assets.texture(t.image)));
            }
        }
        P3.utils.shuffleArray(options);
        return options;
    }
}